<template>
    <div id="m-inbox" style="height: 100%">
        <v-overlay v-if="loading">
            <v-progress-circular indeterminate color="primary"/>
        </v-overlay>
        <v-alert type="error" width="20%" v-else-if="message" style="margin-top: 50px;margin-left: 50%;left: -10%;">
            {{ message }}
        </v-alert>
        <v-card v-else elevation="0">
            <m-maps-set-audience-popup ref="m-maps-set-audience-popup"></m-maps-set-audience-popup>
            <popup-edit-version ref="popup-edit-version"></popup-edit-version>
            <popup-edit-string ref="popup-edit-string"></popup-edit-string>
            <v-card-actions>
                <v-card outlined width="100%" class="ma-0 pa-0">
                    <v-card-actions class="ma-0 pa-2">
                        <v-spacer></v-spacer>
                        <v-btn :disabled="!ifCanImportTmx()"
                                :loading="importingMap"
                                color="blue"
                               elevation="0"
                               class="white--text pl-5 pr-3"
                               @click="onPressImport">
                            Import *.TMX
                            <v-icon class="ml-2">mdi-database-import-outline</v-icon>
                        </v-btn>
                        <input ref="uploader"
                               class="d-none"
                               type="file"
                               accept=".tmx"
                               @change="onFileChanged">
                    </v-card-actions>
                </v-card>
            </v-card-actions>
            <v-card-actions>
                <v-card outlined width="100%" class="ma-0 pa-0">
                    <m-maps-list v-on:show-popup-edit-version="showEditVersionPopup"
                                 v-on:show-m-maps-set-audience-popup="showEditAudiencePopup"
                                 v-on:show-popup-edit-custom-name="showEditCustomName"
                    >></m-maps-list>
                </v-card>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>

import MMapsList from "@/modules/mmaps/views/m-maps-list";
import MapBackend from "@/modules/mmaps/database/MapBackend";
import {MapBackendUtils} from "@/modules/mmaps/database/MapBackendUtils";
import firebase from "firebase";
import MMapsSetAudiencePopup from "@/modules/mmaps/views/popups/m-maps-set-audience-popup";
import {PermissionsStoreUtils} from "@/modules/mpermissions/database/PermissionsStoreUtils";
import {SlackLogManager} from "@/common/SlackLogManager";
import PopupEditVersion from "@/modules/common/popup-edit-version";
import PopupEditString from "@/modules/common/popup-edit-string";

export default {
    components: {PopupEditVersion, MMapsSetAudiencePopup, MMapsList, PopupEditString},
    data: () => ({
        importingMap:false,
        loading: true,
        message: "",
    }),
    methods: {
        ifCanImportTmx(){
            let userUid = PermissionsStoreUtils.getMyUserUid()
            return PermissionsStoreUtils.getPermission(userUid, PermissionsStoreUtils.MAP_TAB.subpermissions.MAP_TAB_IMPORT.id)
        },
        showEditVersionPopup(map){
            let ref = this.$refs['popup-edit-version'];
            ref.show(map.minver, map.maxver, function (min, max) {

                var validateVersion = function (version){
                    var data = version.split(".");
                    var final = "";
                    for (let i = 0; i < data.length; i++) {
                        var int = parseInt(data[i]);
                        if (!Number.isInteger(int)){
                            int = 0;
                        }
                        final += int + (i < data.length - 1 ? "." : "")
                    }
                    return final;
                }

                min = validateVersion(min);
                max = validateVersion(max);

                MapBackendUtils.setMapClientVersion([{name: map.name, "minver":min, "maxver":max}])
                .then(() => {
                    ref.hide()
                    this.$notify({title: 'Map audiences successfully updated!', text: "", type: "succes"});
                })
                .catch((error) => {
                    ref.hide()
                    this.$notify({title: 'Map audiences updated failed!', text: error, type: "error"});
                })
            });
        },
        showEditAudiencePopup(map){
            this.$refs['m-maps-set-audience-popup'].show(map);
        },
        showEditCustomName(map){
            this.$refs['popup-edit-string'].show(map.custom_name, (custom_name) => {
                if (custom_name.length == 0) {
                    this.$notify({title: 'Empty custom name', type: "error"});
                    return;
                }
                this.loading = true;
                MapBackendUtils.setMapCustomName([{name: map.name, "custom_name":custom_name}])
                .then(() => {
                    this.loading = false;
                    this.$notify({title: 'Map custom name successfully updated!', text: "", type: "succes"});
                })
                .catch((error) => {
                    this.loading = false;
                    this.$notify({title: 'Map custom name updated failed!', text: error, type: "error"});
                })
            }, false)
        },
        onPressImport(){
            console.log('onPressImport')
            window.addEventListener('focus', () => {
            }, { once: true })
            this.$refs.uploader.click()
        },
        onFileChanged(e) {
            console.log('onFileChanged: ',e.target.files[0])
            e.target.files[0].text()
                .then((fetchedTmx)=>{
                    let data = {
                        tag:'',
                        group:'',
                        owner: firebase.auth().currentUser.uid,
                        content: fetchedTmx,
                        aud:'',
                        minver:'',
                        maxver:''
                    }
                    this.importingMap = true
                    MapBackendUtils.uploadMap(data)
                    .then((data) => {
                        this.importingMap = false
                        this.dialog = false
                        this.$notify({title: 'Map successfully deployed!', text: "", type: "succes"});

                        console.log(data)

                        let deployData = {
                            'icon_emoji': ':hammer:',
                            'text': "<@"+PermissionsStoreUtils.getMyName()+"> upload new MAP",
                            'attachments': [{
                                'color': '#6500e8',
                                'fields': [
                                    {"title": "Environment", 'value': SlackLogManager.getEnv(), 'short': true},
                                    //{"title": "Name", 'value': config.tag, 'short': true},
                                    //{"title": "Mode", 'value': "delete", 'short': true},
                                    //{"title": "Copy target", 'value': databaseConfig.tag, 'short': true},
                                    //{"title": "Group", 'value': config.group, 'short': true},
                                    //{"title": "Info", 'value': config.info, 'short': true},
                                ]
                            }]
                        }
                        SlackLogManager.log(deployData)
                    })
                    .catch((error) => {
                        this.importingMap = false
                        this.dialog = false
                        this.$notify({title: 'Map deploy failed!', text: error, type: "error"});
                    })
                })
                .catch((error) => {
                    throw error
                })
        }
    },
    beforeMount() {
        this.loading = false
        this.$store.registerModule("maps-backend", MapBackend);
        this.$store.dispatch("maps-backend/init").then(() => {
            console.log("Loaded successfully. maps-backend");
        }).catch(() => {
            this.message = "Load failed!";
        }).finally(() => {
            this.loading = false;
        });
    },
    destroyed() {
        this.$store.unregisterModule("maps-backend");
        console.log("destroy root view maps");
    }
}
</script>

<style scoped>
</style>